"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIP_STATUS_DISCONNECTED = "sipStatus/DISCONNECTED";
exports.SIP_STATUS_CONNECTING = "sipStatus/CONNECTING";
exports.SIP_STATUS_CONNECTED = "sipStatus/CONNECTED";
exports.SIP_STATUS_REGISTERED = "sipStatus/REGISTERED";
exports.SIP_STATUS_ERROR = "sipStatus/ERROR";
exports.SIP_ERROR_TYPE_CONFIGURATION = "sipErrorType/CONFIGURATION";
exports.SIP_ERROR_TYPE_CONNECTION = "sipErrorType/CONNECTION";
exports.SIP_ERROR_TYPE_REGISTRATION = "sipErrorType/REGISTRATION";
exports.CALL_STATUS_IDLE = "callStatus/IDLE";
exports.CALL_STATUS_STARTING = "callStatus/STARTING";
exports.CALL_STATUS_ACTIVE = "callStatus/ACTIVE";
exports.CALL_STATUS_STOPPING = "callStatus/STOPPING";
exports.CALL_DIRECTION_INCOMING = "callDirection/INCOMING";
exports.CALL_DIRECTION_OUTGOING = "callDirection/OUTGOING";
//# sourceMappingURL=enums.js.map